<p-dialog modal="true" styleClass="atlas-dialog-s" position="top" [closable]="false" [(visible)]="show">
  <ng-template pTemplate="header" *ngIf="!loadingPaymentSource">
    <h4>
      {{
      isEditing
      ? ('admin.manage-codes.revenue-codes.payment-source.edit-header' | translate | titlecase)
      : ('admin.manage-codes.revenue-codes.payment-source.add-header' | translate | titlecase)
      }}
    </h4>
  </ng-template>
  <form #crudForm="ngForm" class="atlas-form" [wl-busy-overlay]="loadingPaymentSource" [busyCenter]="true">
    <div class="mct-flex mct-col mct-gap-27" *ngIf="paymentSource">
      <div>
        <label class="light-text">{{ 'common.name' | translate | ucfirst }}</label>
        <input [(ngModel)]="paymentSource.PaymentSource" name="paymentSource" required />
      </div>
      <div>
        <label class="light-text">{{ 'common.description' | translate | ucfirst }}</label>
        <textarea pInputTextarea name="description" [(ngModel)]="paymentSource.Descr" [autoResize]="true"
          [ngClass]="'w-100'"></textarea>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" [disabled]="isSaving" (click)="close()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" [disabled]="!crudForm.valid" (click)="save()">
      <wl-busy [show]="isSaving"></wl-busy>
      <span [hidden]="isSaving">{{ 'common.save' | translate | uppercase }}</span>
    </button>
  </ng-template>
</p-dialog>
